<div class="navigation-header">
  <h1>{{'admin.title' | translate}}</h1>
</div>
<div class="container-card d-flex">
  <mat-card class="card" (click)="goToAccounts()">
    <mat-card-content class="d-flex">
      <fa-icon size="3x" [icon]="accountsIcon"></fa-icon>
    </mat-card-content>
    <mat-card-content class="d-flex">
      <h1>{{'admin.accounts.title' | translate}}</h1>
    </mat-card-content>
  </mat-card>
  <mat-card class="card" (click)="goToUsers()">
    <mat-card-content class="d-flex">
      <fa-icon size="3x" [icon]="usersIcon"></fa-icon>
    </mat-card-content>
    <mat-card-content class="d-flex">
      <h1>{{'admin.users.title' | translate}}</h1>
    </mat-card-content>
  </mat-card>
  <mat-card class="card" (click)="goToChannel()">
    <mat-card-content class="d-flex">
      <fa-icon size="3x" [icon]="channelIcon"></fa-icon>
    </mat-card-content>
    <mat-card-content class="d-flex">
      <h1>{{'admin.channel.title' | translate}}</h1>
    </mat-card-content>
  </mat-card>
  <mat-card class="card" (click)="goToManufacture()">
    <mat-card-content class="d-flex">
      <fa-icon size="3x" [icon]="manufactureIcon"></fa-icon>
    </mat-card-content>
    <mat-card-content class="d-flex">
      <h1>{{'admin.manufacture.title' | translate}}</h1>
    </mat-card-content>
  </mat-card>
</div>
<div class="container-card d-flex">
  <mat-card class="card" (click)="goToCatalogs()">
    <mat-card-content class="d-flex">
      <fa-icon size="3x" [icon]="catalogsIcon"></fa-icon>
    </mat-card-content>
    <mat-card-content class="d-flex">
      <h1>{{'admin.catalogs.title' | translate}}</h1>
    </mat-card-content>
  </mat-card>
  <mat-card class="card" (click)="goToOrdering()">
    <mat-card-content class="d-flex">
      <fa-icon size="3x" [icon]="orderingIcon"></fa-icon>
    </mat-card-content>
    <mat-card-content class="d-flex">
      <h1>{{'admin.electronicOrdering.title' | translate}}</h1>
    </mat-card-content>
  </mat-card>
  <mat-card class="card" (click)="goToBanner()">
    <mat-card-content class="d-flex">
      <fa-icon size="3x" [icon]="bannerIcon"></fa-icon>
    </mat-card-content>
    <mat-card-content class="d-flex">
      <h1>{{'admin.banner.title' | translate}}</h1>
    </mat-card-content>
  </mat-card>
  <mat-card class="card" (click)="goToApex()">
    <mat-card-content class="d-flex">
      <fa-icon size="3x" [icon]="apexIcon"></fa-icon>
    </mat-card-content>
    <mat-card-content class="d-flex">
      <h1>{{'admin.apex.title' | translate}}</h1>
    </mat-card-content>
  </mat-card>
</div>
